import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [savedIds, setSavedIds] = useState([]);

  const loadSaved = useCallback(async () => {
    try {
      const { data } = await api.get("/saved-homes");
      setSavedIds(data.map((d) => d.listing_id));
    } catch { setSavedIds([]); }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("ghc_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); loadSaved(); })
      .catch(() => localStorage.removeItem("ghc_token"))
      .finally(() => setLoading(false));
  }, [loadSaved]);

  const finishAuth = (data) => {
    localStorage.setItem("ghc_token", data.token);
    setUser(data.user);
    loadSaved();
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    finishAuth(data);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    finishAuth(data);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("ghc_token");
    setUser(null); setSavedIds([]);
  };

  const toggleSave = async (listingId) => {
    if (!user) return false;
    if (savedIds.includes(listingId)) {
      await api.delete(`/saved-homes/${listingId}`);
      setSavedIds((s) => s.filter((x) => x !== listingId));
    } else {
      await api.post("/saved-homes", { listing_id: listingId });
      setSavedIds((s) => [...s, listingId]);
    }
    return true;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, savedIds, toggleSave, loadSaved }}>
      {children}
    </AuthCtx.Provider>
  );
}
